(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trenducts-desktop-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trenducts-desktop-header')) {
    customElements.define('trenducts-desktop-header', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.contentObserver) return;
        if (this.querySelector('[data-tdh-ready]')) {
          this.initialize();
          return;
        }
        this.contentObserver = new MutationObserver(() => {
          if (!this.querySelector('[data-tdh-ready]')) return;
          this.contentObserver.disconnect();
          this.contentObserver = null;
          this.initialize();
        });
        this.contentObserver.observe(this, { childList: true, subtree: true });
      }

      initialize() {
        if (!this.isConnected) return;
        if (this.controller) return;
        this.controller = new AbortController();
        this.listenerOptions = { signal: this.controller.signal };
        this.details = this.querySelector('[data-tdh-disclosure]');
        this.summary = this.details.querySelector('summary');
        this.tabs = [...this.querySelectorAll('[data-tdh-tab]')];
        this.panels = [...this.querySelectorAll('[data-tdh-panel]')];
        this.cartLink = this.querySelector('[data-tdh-cart-link]');
        this.tabList = this.querySelector('[data-tdh-tab-list]');
        this.setAttribute('data-enhanced', '');

        if (this.tabList) {
          this.tabList.setAttribute('role', 'tablist');
          this.tabList.setAttribute('aria-orientation', 'horizontal');
          this.tabs.forEach((tab, index) => {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', this.panels[index].id);
            this.panels[index].setAttribute('role', 'tabpanel');
            this.panels[index].setAttribute('aria-labelledby', tab.id);
            tab.addEventListener('click', event => {
              event.preventDefault();
              this.activateCategory(index, true);
            }, this.listenerOptions);
            tab.addEventListener('pointerenter', event => {
              if (event.pointerType === 'mouse') this.activateCategory(index, false);
            }, this.listenerOptions);
            tab.addEventListener('keydown', event => {
              let next = index;
              if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
              else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
              else if (event.key === 'Home') next = 0;
              else if (event.key === 'End') next = this.tabs.length - 1;
              else if (event.key === 'ArrowDown') {
                event.preventDefault();
                this.panels[index].querySelector('a')?.focus();
                return;
              } else if (event.key === ' ') {
                event.preventDefault();
                this.activateCategory(index, true);
                return;
              } else return;
              event.preventDefault();
              this.activateCategory(next, true);
            }, this.listenerOptions);
          });
          this.activateCategory(0, false);
        }

        this.details.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (event.pointerType === 'mouse' && matchMedia('(min-width: 992px)').matches && !this.details.open) {
            this.openedByHover = true;
            this.details.open = true;
          }
        }, this.listenerOptions);
        this.summary.addEventListener('click', event => {
          if (this.openedByHover) {
            event.preventDefault();
            this.openedByHover = false;
            this.details.open = true;
          }
        }, this.listenerOptions);
        this.details.addEventListener('toggle', () => {
          if (!this.details.open) this.openedByHover = false;
        }, this.listenerOptions);
        this.details.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.closeTimer = setTimeout(() => {
            if (!this.details.matches(':focus-within')) this.details.open = false;
          }, 200);
        }, this.listenerOptions);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            this.details.open = false;
            this.summary.focus();
          }
        }, this.listenerOptions);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.details.open = false;
        }, this.listenerOptions);
        this.details.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.details.contains(document.activeElement) && !this.details.matches(':hover')) this.details.open = false;
          });
        }, this.listenerOptions);

        if (this.dataset.cartDrawer === 'true') {
          this.cartLink.addEventListener('click', event => {
            const drawer = document.querySelector('cart-drawer');
            if (!drawer || typeof drawer.open !== 'function') return;
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            drawer.open(this.cartLink);
          }, this.listenerOptions);
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
            const count = event?.cartData?.item_count;
            if (Number.isInteger(count)) this.updateCartCount(count);
            else this.refreshCartCount();
          });
        }
      }

      activateCategory(index, focus) {
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[tabIndex].hidden = !active;
        });
        if (focus) this.tabs[index].focus();
      }

      updateCartCount(count) {
        this.querySelector('[data-tdh-cart-count]').textContent = count;
        const label = this.querySelector('[data-tdh-cart-accessible]');
        label.textContent = label.dataset.labelTemplate.replace('__COUNT__', String(count));
      }

      refreshCartCount() {
        if (this.cartRequest) return this.cartRequest;
        this.cartRequest = fetch(this.dataset.cartJsonUrl, { signal: this.controller.signal, headers: { Accept: 'application/json' } })
          .then(response => {
            if (!response.ok) throw new Error(String(response.status));
            return response.json();
          })
          .then(cartData => this.updateCartCount(cartData.item_count))
          .catch(() => {})
          .finally(() => { this.cartRequest = null; });
        return this.cartRequest;
      }

      disconnectedCallback() {
        this.contentObserver?.disconnect();
        this.contentObserver = null;
        clearTimeout(this.closeTimer);
        this.controller?.abort();
        this.unsubscribeCart?.();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
